import React from 'react';
import EdExpWrapper from './EdExpWrapper';
import HackathonExperienceSlider from './HackathonExperienceSlider';

const Experience = ({ data }) => {
    return (
        <div className='text-white'>
            {data && data.experience && (
                <>
                    <EdExpWrapper
                        items={data.experience}
                        title={'Experience'}
                    />
                    <div>
                        <HackathonExperienceSlider data={data} />
                    </div>
                </>
            )}
        </div>
    );
};

export default Experience;
